import React from 'react';
import {
  List, Datagrid, TextField, EditButton, DeleteButton, ReferenceField, ChipField,
  NumberField, UrlField, Filter, ReferenceInput, SelectInput
} from 'react-admin';

const ListFilters = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Wind Turbine"
      source="windTurbineId"
      reference="windTurbines"
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={searchText => ({ name: searchText })}
      allowEmpty={true}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export default (props) => (
  <List {...props} filters={<ListFilters />} sort={{ field: 'sortOrder', order: 'ASC' }}>
    <Datagrid>
      <ReferenceField label="Wind Turbine" source="windTurbine.id" reference="windTurbines" link="edit">
        <ChipField source="name" />
      </ReferenceField>
      <TextField source="label" />
      <UrlField source="url" />
      <NumberField source="sortOrder" label="Order" />
      <EditButton label="Edit" />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
